var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dean-header-search"},[_c('dean-search-field',{attrs:{"value":_vm.value,"animate":""}},[_vm._v("Zoek alles")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }